

import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { CourseListResponse, getCourses } from "../../../../api/courses";

interface UseLiveTeachingListParams {
  initialPage?: number;
  initialLimit?: number;
  isAdmin?: boolean;
}

export const useLiveTeachingList = ({
  initialPage = 1,
  initialLimit = 10,
  isAdmin = true,
}: UseLiveTeachingListParams) => {
  const [page, setPage] = useState(initialPage);
  const [limit, setLimit] = useState(initialLimit);
  const [search, setSearch] = useState("");

  useEffect(() => {
    setPage(1);
  }, [search]);

  const responseQuery = useQuery<CourseListResponse>({
    queryKey: ["admin-live-teaching", { page, limit, search }],
    queryFn: () => getCourses({ page, limit, search, type: 'Live_Teaching' }, isAdmin),
    refetchInterval: 60000,
    refetchIntervalInBackground: true,
  });

  const onPaginationChange = (pagination: { current: number; pageSize: number }) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
  };

  return {
    ...responseQuery,
    page,
    limit,
    search,
    setSearch,
    onPaginationChange,
  };
};